import { z } from 'zod';
const types = [
    'document',
    'case_study',
    'article',
    'blog',
    'white_paper',
    'report',
    'video',
    'podcast',
    'interview',
    'other',
];
const typeSet = new Set(types);
// See research/research-fixtures/public/sources.md
export const SourceContentPropertiesSchema = z.object({
    publisher: z.string().nullable(),
    url: z.string().nullable(),
    type: z
        .string()
        .transform((value) => (typeSet.has(value) ? value : 'other'))
        .pipe(z.enum(types))
        .nullable(),
    published_at: z.date({ coerce: true }).nullable().optional(),
    // detailedMetrics: z.number(),
    // relevanceToUseCase: z.number(),
    // reliabilityOfSource: z.number(),
    // strategicAndTacticalInformation: z.number(),
    // technicalImplementationDetails: z.number(),
    // noVendorBias: z.number(),
    // relevanceToClient: z.number(),
});
export const ReportSourceObjectSchema = z.object({
    id: z.string(),
    displayName: z.string(),
    url: z.string().nullable(),
});
//# sourceMappingURL=reportSourceSchema.js.map